import { actionSchema } from 'window-messages';
import { action } from 'ts-action';

export interface LockSaveAction {
  locked: boolean;
}

export const LockSave = actionSchema('Lock save');
export const lockSave = action('Lock save', (locked: boolean = true): LockSaveAction => ({ locked }));
